import React from 'react';
import PropTypes from 'prop-types';
import {Heading, Anchor} from '@albert-io/atomic';
import {removeQueryParams} from 'client/history';
import './no-results-for-selected-due-dates.scss';

export default class NoResultsForSelectedDueDates extends React.PureComponent {
  static propTypes = {
    hasAssignments: PropTypes.bool,
    query: PropTypes.object
  };

  static defaultProps = {
    hasAssignments: false
  };

  render() {
    const {query} = this.props;
    const showResetButton = Object.keys(query)
      .filter((key) => key !== 'assignmentStatus' && key !== 'search' && key !== 'page')
      .some((key) => query[key]);

    if (this.props.hasAssignments) {
      return null;
    }

    return (
      <div className='u-text-align_center'>
        <Heading size='s' className='u-mar-tb_2'>
          No results found
        </Heading>
        {showResetButton && (
          <Anchor
            as='button'
            onClick={() => {
              removeQueryParams('start', 'end', 'range', 'type', 'search');
            }}
          >
            Reset assignment filters
          </Anchor>
        )}
      </div>
    );
  }
}
